import i18n from "./i18n.ts";

const translationKeys = {
  "conference champs": "conferenceChamps",
  "league champs": "leagueChamps",
  "made conference finals": "madeConferenceFinals",
  "made conference semifinals": "madeConferenceSemifinals",
  "made finals": "madeFinals",
  "made playoffs": "madePlayoffs",
  "made quarterfinals": "madeQuarterfinals",
  "made semifinals": "madeSemifinals",
} as const;

export const translateRoundsWonText = (roundsWonText: string) => {
  if (roundsWonText.trim().length === 0) {
    return roundsWonText;
  }

  const normalized = roundsWonText.trim().toLowerCase();
  const key = translationKeys[normalized as keyof typeof translationKeys];
  if (!key || !i18n.isInitialized) {
    return roundsWonText;
  }

  const translated = i18n.t(`roundsWonText.${key}`, {
    ns: "ui",
    defaultValue: roundsWonText,
  });
  return typeof translated === "string" && translated.length > 0 ? translated : roundsWonText;
};
